export const THEME_MODE_STORAGE_KEY = 'soccertycs.theme-mode';

export const getStoredThemeMode = () => {
  if (typeof window === 'undefined') return 'light';

  const themeMode = window.localStorage.getItem(THEME_MODE_STORAGE_KEY);
  return themeMode === 'dark' || themeMode === 'light' ? themeMode : 'light';
};

export const saveThemeMode = (themeMode) => {
  window.localStorage.setItem(THEME_MODE_STORAGE_KEY, themeMode);
};
